// extracted by mini-css-extract-plugin
export default {"wrapper":"video-camera_wrapper__LfFvN","camera_video":"video-camera_camera_video__O-MA7","video_tip":"video-camera_video_tip__zDRA1"};